import permissions from '../permission-list'

export default [
  {
    path: '/v2/users',
    name: 'users-v2',
    component: () => import('@/views/v2/Users.vue'),
    meta: {
      pageTitle: 'Pembeli',
      resource: permissions.userV2,
      action: 'read',
      navActiveLink: 'users-v2',
      breadcrumb: [
        { text: 'Pembeli', active: true },
      ],
    },
  },
  {
    path: '/v2/users/:id/detail',
    name: 'users-v2-detail',
    component: () => import('@/views/v2/UserDetail.vue'),
    meta: {
      pageTitle: 'Detail Pembeli',
      resource: permissions.userV2,
      action: 'read',
      navActiveLink: 'users-v2',
      breadcrumb: [
        { text: 'Pembeli', to: { name: 'users-v2' } },
        { text: 'Detail', active: true },
      ],
    },
  },
  {
    path: '/v2/users/:id/edit',
    name: 'users-v2-edit',
    component: () => import('@/views/v2/UserEdit.vue'),
    meta: {
      pageTitle: 'Edit Pembeli',
      resource: permissions.userV2,
      action: 'manage',
      navActiveLink: 'users-v2',
      breadcrumb: [
        { text: 'Pembeli', to: { name: 'users-v2' } },
        { text: 'Edit', active: true },
      ],
    },
  },
]
